import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import PaymentLink from "../../payment/types/PaymentLink";
import {useCallback} from "react";
import {Tpv} from "../../payment/enum/Tpv";

interface PayWithSavedCardInput {
    bookingId: string;
    bookingInternalId: string;
    tpv: Tpv;
    paymentCardUuid?: string;
    scheduledAt?: string;
}

export default function useBookingPayWithSavedCard() {
    const client = useAPIClient();

    return useCallback(({bookingInternalId, bookingId, tpv, paymentCardUuid, scheduledAt}: PayWithSavedCardInput): Promise<PaymentLink> => {
        return client.post<PaymentLink>(`bookings/${bookingInternalId}/payment_link`, {
            booking: bookingId,
            tpv: tpv,
            paymentCard: paymentCardUuid,
            ...(scheduledAt ? {scheduledAt} : {}),
        });
    }, [client]);
}
